import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyDc6QajbzaalGUlcz0CgX53kOH7jjMiXzw",
  authDomain: "scheduling-web-app-f4bfa.firebaseapp.com",
  projectId: "scheduling-web-app-f4bfa",
  storageBucket: "scheduling-web-app-f4bfa.firebasestorage.app",
  messagingSenderId: "734750624426",
  appId: "1:734750624426:web:d9b4807f3941df08499ed3",
  measurementId: "G-JVYR984PW3"

};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);

export { db, auth };